import {colors} from '../../../foundation/colors';
import {spacing} from '../../../foundation/spacing';

export const MuiInputBase = {
  input: {
    height: spacing(5),
    padding: spacing(3, 0),
    borderColor: colors.gray[400],
  },
  sizeSmall: {
    '& .MuiInputBase-input': {
      paddingTop: spacing(2),
      paddingBottom: spacing(2),
    },
  },
};
